import {
  GET_USER_TRAINING,
  USER_TRAINING_PAYMENT,
  TRAINING_RECEIPT,
  USER_TRAINING_REGISTER,
} from "../../constants/api_constants";
import { handleApi } from "../utils";

export const getUserTraining = async () => {
  return handleApi("get", GET_USER_TRAINING);
};

export const userTrainingPayment = async (values) => {
  return handleApi("post", USER_TRAINING_PAYMENT, values);
};

export const userTrainingRegister = async (values) => {
  return handleApi("post", USER_TRAINING_REGISTER, values);
};

export const userTrainingReceipt = async (id) => {
  return handleApi("get", `${TRAINING_RECEIPT}/${id}`);
};
